import { Button, Table } from "antd";
import {
    PlusOutlined
} from "@ant-design/icons"
const TableLayout = (props) => {
    const { columns, dataSource, setAddElementModal, total = 0, getData = null, displayAddBtn } = props
    return (
        <>
            <div>
                <div
                    style={{
                        display: "flex",
                        textAlign: "center",
                        justifyContent: "flex-end",
                        padding: "10px"
                    }}
                >
                    {!displayAddBtn && <Button
                        onClick={() => setAddElementModal(true)}
                    >
                        <PlusOutlined
                            style={{
                                fontSize: "20px",
                                cursor: "pointer"
                            }}
                        />
                    </Button>}
                </div>
                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                    <Table
                        pagination={{
                            total: total,
                            onChange: (page, pageSize) => {
                                if (getData) {
                                    getData(page, pageSize);
                                }
                            }
                        }}
                        columns={columns}
                        dataSource={dataSource}
                        rowKey='id'
                        locale={{
                            emptyText: "Aucune donnée trouvée"
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export default TableLayout;